import qs from 'query-string';
import equal from 'fast-deep-equal';

import getConfig from './config';

/**
 * Appends params from a search query to our mobile apps strings. Useful when we need to create
 * custom links with branch match link ids and the like.
 *
 * @param {String} searchQuery The search queyr string whose params will be appended to those of the mobile app.
 */
const mobileUrlsAppendQueryParams = searchQuery => {
  const { mobile } = getConfig();
  const { androidAppUrl, iosAppUrl } = mobile;

  const baseAndroidQueryString = androidAppUrl.slice(
    androidAppUrl.lastIndexOf('?') + 1,
  );

  const baseIosQueryString = iosAppUrl.slice(iosAppUrl.lastIndexOf('?') + 1);

  const androidQueryParams = {
    ...qs.parse(baseAndroidQueryString),
    ...qs.parse(searchQuery),
  };

  const iosQueryParams = {
    ...qs.parse(baseIosQueryString),
    ...qs.parse(searchQuery),
  };

  return {
    androidAppUrl: `${androidAppUrl.slice(
      0,
      androidAppUrl.lastIndexOf('?'),
    )}?${qs.stringify(androidQueryParams)}`,

    iosAppUrl: `${iosAppUrl.slice(
      0,
      iosAppUrl.lastIndexOf('?'),
    )}?${qs.stringify(iosQueryParams)}`,
  };
};

/**
 * Checks if the current form (current state) is equal from the baseForm or not.
 *
 * Deep-equal should handle this simply by calling equal on the base object, but it is possible,
 * and likely, that the current form contains elements pertaining the status of the form (submitted, loading, etc) that
 * are not relevant to the base form, so instead, a per-key assesment is performed. Deep-equal is used to ensure
 * objects within the forms are compared accordingly.
 *
 * @param {Object} baseForm The base form - core only. Should not contain success/loading/etc states, only pure-form elements.
 * @param {*} currentForm Current status of the form (generally the current state).
 */
const isFormDirty = (baseForm, currentForm) => {
  return !!Object.keys(baseForm).find(key => {
    return !equal(baseForm[key], currentForm[key]);
  });
};

/**
 * Toggles full screen view for the given element
 *
 * @param {Node} element the DOM element to full screen
 */
const onFullScreenToggle = element => {
  if (
    document.fullscreenElement ||
    document.mozFullScreenElement ||
    document.webkitFullscreenElement ||
    document.msFullScreenElement
  ) {
    if (document.exitFullscreen) {
      document.exitFullscreen();
      return;
    }
    /* Mozilla */
    if (document.mozExitFullscreen) {
      document.mozExitFullscreen();
      return;
    }
    /* Safari */
    if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
      return;
    }
    /* IE11 */
    if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  } else {
    if (element?.requestFullscreen) {
      element?.requestFullscreen?.();
      return;
    }
    /* Mozilla */
    if (element?.mozRequestFullscreen) {
      element?.mozRequestFullscreen?.();
      return;
    }
    /* Safari */
    if (element?.webkitRequestFullscreen) {
      element?.webkitRequestFullscreen();
      return;
    }
    /* IE11 */
    if (element?.msRequestFullscreen) {
      element?.msRequestFullscreen();
    }
  }
};
export { mobileUrlsAppendQueryParams, isFormDirty, onFullScreenToggle };
